import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

export type ZoomValues = 1 | 0.75 | 0.5 | 0.35;
type ReturnType = [ZoomValues, (val: ZoomValues) => void, boolean];

const zoomAtom = atom<ZoomValues>(1);

export const useZoom = (): ReturnType => {
	const [zoom, setZoom] = useAtom(zoomAtom);
	const { pathname } = useLocation();
	const isZoomEnabled = pathname.includes('activity-map');

	useEffect(() => {
		if (!isZoomEnabled) {
			setZoom(1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isZoomEnabled]);

	return [zoom, setZoom, isZoomEnabled];
};
